export enum LeaderboardFilterMode {
	ROUNDS = 'ROUNDS',
	SLATES = 'SLATES',
}
